import { GetStartedType } from "components/Navbar/GetStartedButton"
import { graphql, Link } from "gatsby"
import { MDXRenderer } from "gatsby-plugin-mdx"
import * as React from "react"
import * as styles from "./styles.module.scss"
import Body from "./Body"
import cx from "classnames"
import Document from "components/Document"
import Footer from "components/Footer"
import Header from "./Header"
import Img from "gatsby-image"
import Navbar from "components/Navbar"
import PageWrapper, { PaddingTop } from "components/PageWrapper"
import ReadNext from "./ReadNext"
import SideNav from "components/SideNav"
import SubNavbarResources from "../SubNavbarResources"
import Tag from "./Tag"
import Tags, { TagsType } from "./Tags"

export interface PostProps {
  children: React.ReactNode
  className?: string
  data: any
}

const Post: React.FC<PostProps> = ({ data: { mdx }, className }: IProps) => {
  const { title, author, date, tags, avatar, image } = mdx.frontmatter
  const avatarSrc = avatar?.childImageSharp.fluid.src
  return (
    <Document title={title}>
      <Navbar getStartedType={GetStartedType.ON_SCROLL} />
      <SubNavbarResources />
      <SideNav />
      <PageWrapper paddingTop={PaddingTop.SubNavbar}>
        <main className={styles.content} role="main">
          <article
            className={cx({
              [styles.post]: true,
              [className]: className,
            })}
          >
            <div className={styles.pagePadding}>
              <div className={styles.header}>
                <Header
                  date={date}
                  avatarSrc={avatarSrc}
                  avatarAlt={`${author} photo`}
                  title={title}
                  author={author}
                />
              </div>
              <Body>
                {image?.childImageSharp && (
                  <Img
                    fluid={image.childImageSharp.fluid}
                    className={styles.image}
                  />
                )}
                <MDXRenderer>{mdx.body}</MDXRenderer>
              </Body>
              {tags && (
                <div className={styles.tags}>
                  <Tags type={TagsType.POST}>
                    {tags.map((tag) => (
                      <li className={styles.tag} key={tag}>
                        <Link to={tag} title={tag}>
                          <Tag>{tag}</Tag>
                        </Link>
                      </li>
                    ))}
                  </Tags>
                </div>
              )}
            </div>
          </article>
          <ReadNext />
          <Footer />
        </main>
      </PageWrapper>
    </Document>
  )
}

export default Post

export const pageQuery = graphql`
  query BlogPost($id: String) {
    mdx(id: { eq: $id }) {
      body
      id
      frontmatter {
        avatar {
          childImageSharp {
            fluid(maxWidth: 400) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        image {
          childImageSharp {
            fluid(maxWidth: 400) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        author
        date
        tags
        title
      }
      timeToRead
      fields {
        slug
      }
    }
  }
`
